import { live_decision_drawers } from './delegation_live_decision_data';

export const exception_requests = [
  {
    transaction: 'Platform support agreement',
    value: 'R 520 000',
    approved_by: 'M. Khan (CFO)',
    should_have_been: 'CFO + CEO',
    escalated_to: 'CEO',
    what_happened: 'Approved outside the authority matrix',
    reason: 'Urgent contract renewal',
    drawer_key: 'exception_platform_support',
    status: { label: 'Escalated', class: 'bg-danger-subtle text-danger-emphasis' }
  },
  {
    transaction: 'Emergency IT hardware',
    value: 'R 180 000',
    approved_by: 'R. Govender (CISO)',
    should_have_been: 'SCM Manager + 3 quotes',
    escalated_to: 'EXCO',
    what_happened: 'Purchased without 3 quotes during outage',
    reason: 'System-down emergency',
    drawer_key: 'exception_emergency_it_hardware',
    status: { label: 'Ratified', class: 'bg-success-subtle text-success-emphasis' }
  },
  {
    transaction: 'NewGX reseller agreement',
    value: 'R 520 000',
    approved_by: 'Procurement lead',
    should_have_been: 'Legal + CFO',
    escalated_to: 'CFO + Legal',
    what_happened: 'Contract signed without legal approval',
    reason: 'Commercial urgency',
    drawer_key: 'exception_newgx_reseller',
    status: { label: 'Logged', class: 'bg-warning-subtle text-warning-emphasis' }
  }
];

export const drawer_catalog = {
  ...live_decision_drawers,
  contract_breach: {
    section: 'CONTRACT - DOA BREACH',
    title: 'Platform support agreement',
    subtitle: 'NewGX Capital - R 520 000 - CFO + CEO required',
    status: 'Pending',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    details_layout: 'list',
    details: [
      { label: 'Contract', value: 'Platform support agreement' },
      { label: 'Counterparty', value: 'NewGX Capital' },
      { label: 'Value', value: 'R 520 000 - annual' },
      { label: 'Term', value: '24 months' },
      { label: 'Owner', value: 'Legal - A. de Wet' },
      { label: 'Status', value: 'CFO + CEO approval', value_class: 'text-warning-emphasis' }
    ],
    sections: [
      {
        title: 'DOA evaluation',
        badge: 'Triggered',
        badge_class: 'bg-warning-subtle text-warning-emphasis',
        kind: 'items',
        items: [
          { title: 'Contract value exceeds R 500 000 threshold', subtitle: 'Rule DoA-014 - Board policy v1', meta: 'Triggered', icon: 'bi-file-earmark-arrow-up', icon_class: 'is-orange' },
          { title: 'Change-control clause', subtitle: 'Legal must confirm presence before signature', meta: 'Pending', icon: 'bi-clipboard-check', icon_class: 'is-orange' },
          { title: 'Counterparty due diligence', subtitle: 'Approved supplier - low risk', meta: 'Cleared', icon: 'bi-check-circle', icon_class: 'is-green' }
        ]
      },
      {
        title: 'Approval chain',
        badge: 'Waiting',
        badge_class: 'bg-warning-subtle text-warning-emphasis',
        kind: 'timeline',
        items: [
          { title: 'Legal review', subtitle: 'Draft cleared by Legal', meta: '11 May - 17:40', icon: 'bi-check-circle-fill', icon_class: 'is-green', connected: true },
          { title: 'CFO approval', subtitle: 'Awaiting sign-off - DoA threshold breached', meta: '', icon: 'bi-record-circle', icon_class: 'is-slate', connected: true },
          { title: 'CEO approval', subtitle: 'Required because value > R 500 000', meta: '', icon: 'bi-person', icon_class: 'is-slate', connected: true },
          { title: 'Signature & filing', subtitle: 'Evidence stored in vault', meta: '', icon: 'bi-paperclip', icon_class: 'is-slate', connected: false }
        ]
      }
    ],
    footer_actions: [
      { label: 'Ask AI', variant: 'ghost', icon: 'bi-stars', position: 'left' },
      { label: 'Remind CFO', variant: 'outline-secondary', icon: 'bi-bell', position: 'right' },
      { label: 'Route to CFO', variant: 'primary', icon: 'bi-send', position: 'right' }
    ]
  },
  exception_platform_support: {
    section: 'CONTRACT - DOA BREACH',
    title: 'Platform support agreement',
    subtitle: 'NewGX Capital - R 520 000 - CFO + CEO required',
    status: 'Pending',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    details_layout: 'list',
    details: [
      { label: 'Contract', value: 'Platform support agreement' },
      { label: 'Counterparty', value: 'NewGX Capital' },
      { label: 'Value', value: 'R 520 000 - annual' },
      { label: 'Term', value: '24 months' },
      { label: 'Owner', value: 'Legal - A. de Wet' },
      { label: 'Status', value: 'CFO + CEO approval', value_class: 'text-warning-emphasis' }
    ],
    sections: [
      {
        title: 'DOA evaluation',
        badge: 'Triggered',
        badge_class: 'bg-warning-subtle text-warning-emphasis',
        kind: 'items',
        items: [
          { title: 'Contract value exceeds R 500 000 threshold', subtitle: 'Rule DoA-014 - Board policy v1', meta: 'Triggered', icon: 'bi-file-earmark-arrow-up', icon_class: 'is-orange' },
          { title: 'Change-control clause', subtitle: 'Legal must confirm presence before signature', meta: 'Pending', icon: 'bi-clipboard-check', icon_class: 'is-orange' },
          { title: 'Counterparty due diligence', subtitle: 'Approved supplier - low risk', meta: 'Cleared', icon: 'bi-check-circle', icon_class: 'is-green' }
        ]
      },
      {
        title: 'Approval chain',
        badge: 'Waiting',
        badge_class: 'bg-warning-subtle text-warning-emphasis',
        kind: 'timeline',
        items: [
          { title: 'Legal review', subtitle: 'Draft cleared by Legal', meta: '11 May - 17:40', icon: 'bi-check-circle-fill', icon_class: 'is-green', connected: true },
          { title: 'CFO approval', subtitle: 'Awaiting sign-off - DoA threshold breached', meta: '', icon: 'bi-record-circle', icon_class: 'is-slate', connected: true },
          { title: 'CEO approval', subtitle: 'Required because value > R 500 000', meta: '', icon: 'bi-person', icon_class: 'is-slate', connected: true },
          { title: 'Signature & filing', subtitle: 'Evidence stored in vault', meta: '', icon: 'bi-paperclip', icon_class: 'is-slate', connected: false }
        ]
      }
    ],
    footer_actions: [
      { label: 'Ask AI', variant: 'ghost', icon: 'bi-stars', position: 'left' },
      { label: 'Remind CFO', variant: 'outline-secondary', icon: 'bi-bell', position: 'right' },
      { label: 'Route to CFO', variant: 'primary', icon: 'bi-send', position: 'right' }
    ]
  },
  exception_emergency_it_hardware: {
    section: 'PROCUREMENT - DOA BREACH',
    title: 'Emergency IT hardware',
    subtitle: 'R 180 000 - SCM Manager + 3 quotes required',
    status: 'Ratified',
    status_class: 'bg-success-subtle text-success-emphasis',
    details_layout: 'list',
    details: [
      { label: 'Transaction', value: 'Emergency IT hardware' },
      { label: 'Counterparty', value: 'IT supplier' },
      { label: 'Value', value: 'R 180 000' },
      { label: 'Term', value: 'Spot purchase' },
      { label: 'Owner', value: 'R. Govender (CISO)' },
      { label: 'Status', value: 'EXCO ratified', value_class: 'text-success-emphasis' }
    ],
    sections: [
      {
        title: 'DOA evaluation',
        badge: 'Triggered',
        badge_class: 'bg-warning-subtle text-warning-emphasis',
        kind: 'items',
        items: [
          { title: 'Procurement threshold exceeded during outage', subtitle: 'Rule DoA-021 - Emergency procurement', meta: 'Triggered', icon: 'bi-lightning-charge', icon_class: 'is-orange' },
          { title: 'Three quotes not obtained', subtitle: 'Exception recorded with system-down justification', meta: 'Pending', icon: 'bi-clipboard-x', icon_class: 'is-orange' },
          { title: 'Counterparty due diligence', subtitle: 'Approved vendor - urgent replacement', meta: 'Cleared', icon: 'bi-check-circle', icon_class: 'is-green' }
        ]
      },
      {
        title: 'Approval chain',
        badge: 'Waiting',
        badge_class: 'bg-warning-subtle text-warning-emphasis',
        kind: 'timeline',
        items: [
          { title: 'SCM review', subtitle: 'Emergency memo reviewed by SCM', meta: '20 Apr - 09:15', icon: 'bi-check-circle-fill', icon_class: 'is-green', connected: true },
          { title: 'CFO ratification', subtitle: 'Ratified after emergency justification', meta: '20 Apr - 10:40', icon: 'bi-check-circle-fill', icon_class: 'is-green', connected: true },
          { title: 'EXCO notification', subtitle: 'Logged for governance oversight', meta: '', icon: 'bi-person-check', icon_class: 'is-slate', connected: true },
          { title: 'Archive', subtitle: 'Evidence stored in vault', meta: '', icon: 'bi-paperclip', icon_class: 'is-slate', connected: false }
        ]
      }
    ],
    footer_actions: [
      { label: 'Ask AI', variant: 'ghost', icon: 'bi-stars', position: 'left' },
      { label: 'Remind CFO', variant: 'outline-secondary', icon: 'bi-bell', position: 'right' },
      { label: 'Route to CFO', variant: 'primary', icon: 'bi-send', position: 'right' }
    ]
  },
  exception_newgx_reseller: {
    section: 'CONTRACT - DOA BREACH',
    title: 'NewGX reseller agreement',
    subtitle: 'R 520 000 - Legal + CFO required',
    status: 'Logged',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    details_layout: 'list',
    details: [
      { label: 'Contract', value: 'NewGX reseller agreement' },
      { label: 'Counterparty', value: 'NewGX Capital' },
      { label: 'Value', value: 'R 520 000' },
      { label: 'Term', value: 'Reseller agreement' },
      { label: 'Owner', value: 'Procurement lead' },
      { label: 'Status', value: 'CFO + Legal escalation', value_class: 'text-warning-emphasis' }
    ],
    sections: [
      {
        title: 'DOA evaluation',
        badge: 'Triggered',
        badge_class: 'bg-warning-subtle text-warning-emphasis',
        kind: 'items',
        items: [
          { title: 'Contract value exceeds procurement threshold', subtitle: 'Rule DoA-017 - Contract policy v1', meta: 'Triggered', icon: 'bi-file-earmark-arrow-up', icon_class: 'is-orange' },
          { title: 'Legal review missing', subtitle: 'Agreement signed without legal approval', meta: 'Pending', icon: 'bi-exclamation-triangle', icon_class: 'is-orange' },
          { title: 'Counterparty due diligence', subtitle: 'Commercial urgency recorded', meta: 'Logged', icon: 'bi-info-circle', icon_class: 'is-green' }
        ]
      },
      {
        title: 'Approval chain',
        badge: 'Waiting',
        badge_class: 'bg-warning-subtle text-warning-emphasis',
        kind: 'timeline',
        items: [
          { title: 'Procurement lead review', subtitle: 'Contract prepared for approval', meta: '11 May - 10:30', icon: 'bi-check-circle-fill', icon_class: 'is-green', connected: true },
          { title: 'Legal review', subtitle: 'Required before signature', meta: '', icon: 'bi-record-circle', icon_class: 'is-slate', connected: true },
          { title: 'CFO approval', subtitle: 'Needed because value > R 500 000', meta: '', icon: 'bi-person', icon_class: 'is-slate', connected: true },
          { title: 'Signature & filing', subtitle: 'Evidence stored in vault', meta: '', icon: 'bi-paperclip', icon_class: 'is-slate', connected: false }
        ]
      }
    ],
    footer_actions: [
      { label: 'Ask AI', variant: 'ghost', icon: 'bi-stars', position: 'left' },
      { label: 'Remind CFO', variant: 'outline-secondary', icon: 'bi-bell', position: 'right' },
      { label: 'Route to CFO', variant: 'primary', icon: 'bi-send', position: 'right' }
    ]
  }
};

